/* eslint-disable react/display-name */
import { useTranslation } from 'react-i18next';
import { useValidatePath } from '../../../hooks/useValidatePath';
import { PAGE_TITLE } from '../../../utils/constants/general';
import React from 'react';
import ErrorPage from '../../ErrorPage';
import categoryLocalization from '../../../locales/en/category.json';

export const withPathValidation = WrappedPage => props => {
	const { t } = useTranslation(['category']);
	const { category, isValidating, isInvalidPath } = useValidatePath();

	function createDocumentTitle() {
		const postfix = ' - ' + PAGE_TITLE;
		const title = t('category:' + category.id + '.title');
		const abbreviation = categoryLocalization[category.id].abbreviation;

		return abbreviation ? t('category:' + category.id + '.abbreviation') + postfix : title + postfix;
	}

	if (isValidating) return <div />;
	if (isInvalidPath) return <ErrorPage message="pageNotFound" />;

	document.title = createDocumentTitle();

	return <WrappedPage category={category} {...props} />;
};
